import { UploadChatTeleconsultationDocumentParams } from 'common/types/chat';
import axiosInstance from './axiosInstance';
import axiosBlobInstance from './axiosBlobInstance';

/**
 * API for chat teleconsultation.
 */
export const ChatTeleconsultationAPI = {
  /**
   * Uploads a document to a chat teleconsultation conversation.
   *
   * @param conversationSid - The SID of the conversation.
   * @param file - The file to upload.
   * @returns A Promise that resolves to the response from the API.
   */
  uploadChatTeleconsultationDocument: ({
    conversationSid,
    file,
  }: UploadChatTeleconsultationDocumentParams) => {
    return axiosInstance.post(
      `/pro-side/chat-teleconsultation/documents/${conversationSid}/upload`,
      file,
    );
  },

  /**
   * Downloads a document from a chat teleconsultation message.
   *
   * @param messageSid - The SID of the message.
   * @returns A Promise that resolves to the response from the API.
   */
  downloadChatTeleconsultationDocument: (messageSid: string) => {
    return axiosBlobInstance.get(
      `/pro-side/chat-teleconsultation/documents/${messageSid}/download`,
    );
  },

  /**
   * Deletes a document message from a chat teleconsultation conversation.
   *
   * @param messageSid - The SID of the message to delete.
   * @returns A Promise that resolves to the response from the API.
   */
  deleteChatDocumentMessage: (messageSid: string) => {
    return axiosInstance.delete(
      `/pro-side/chat-teleconsultation/documents/${messageSid}`,
    );
  },

  /**
   * Generates an access token for a chat teleconsultation room.
   *
   * @param roomId - The ID of the room.
   * @returns A Promise that resolves to the response from the API.
   */
  getChatAccessToken: (roomId: string) => {
    return axiosInstance.post<string>(
      `/pro-side/chat-teleconsultation/${roomId}/generate-access-token`,
      { roomId },
    );
  },
};
